<template>

    <tq-list :style="{'direction' : helper_getDirectionByLangCode_fe(p_display_langCode_e)}"
             class="mission">

        <!-- image -->
        <tq-on-top-container slot="img">

            <img v-if="m_showFinishIcon_b(p_qb_riddle_c)"
                 slot="middle"
                 :src="ass_img_checked"
                 class="TQ_padding_2px TQ_bg_circle TQ_bg_white TQ_center"
                 :class="p_windowSizeType_e > enum_screenSizesOptions_n.mobile ? 'TQ_width_36px' : 'TQ_width_19px'"
            />

            <div v-else slot="bottom" class="TQ_textColor_black TQ_text_14px TQ_center">
                <div class="TQ_bg_gold" v-if="m_getWaitingToApprovedImgsNum_fn(p_qb_riddle_c) > 0">
                    {{m_getWaitingToApprovedImgsNum_fn(p_qb_riddle_c)}}
                </div>
                <div class="TQ_bg_red " v-if="m_getNotApprovedImgsNum_fn(p_qb_riddle_c) > 0">
                    {{m_getNotApprovedImgsNum_fn(p_qb_riddle_c)}}
                </div>
            </div>

            <div :class="p_windowSizeType_e > enum_screenSizesOptions_n.mobile ? 'TQ_width_100px' : 'TQ_width_64px'" slot="body">
                <tq-img-fill-blur :p_height_s="p_windowSizeType_e > enum_screenSizesOptions_n.mobile ? '72px' : '48px'"
                                  :pp_img-url_s="p_qb_riddle_c.qbr_imgFile_blc_c[p_display_langCode_e]
                                             ? p_qb_riddle_c.qbr_imgFile_blc_c[p_display_langCode_e].fi_url_s
                                             : ass_img_image"/>
            </div>

        </tq-on-top-container>


        <!-- text -->
        <div slot="title" class="TQ_grid_col_1frAuto TQ_grid_center TQ_margin_top_2px">
            <div :class="p_windowSizeType_e > enum_screenSizesOptions_n.mobile ? 'TQ_text_24px' : 'TQ_text_20px' " >
                {{p_qb_riddle_c.qbr_title_blc_s[p_display_langCode_e]}}
            </div>

            <div class="TQ_text_14px TQ_margin_4px" v-if="p_supportPoints_b">
                {{p_qb_riddle_c.cm_gbr_totalPoints_n()}} {{ass_strings.oneWord_points[p_display_langCode_e]}}
            </div>
        </div>

        <!-- description -->
        <div slot="description" class="TQ_text_14px TQ_margin_bottom_4px TQ_verticalAlignMiddle">
            {{p_qb_riddle_c.qbr_subtitle_blc_s[p_display_langCode_e]}}
        </div>

    </tq-list>
</template>

<script>
    import TqList from "./TqList";
    import {
        helper_finishRiddle_fb,
        helper_getDirectionByLangCode_fe
    } from "../../scripts/S_Helper";
    import {enum_lockState, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import { validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import { ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import { ass_img_checked, ass_img_image} from "../../assets/scripts/Ass_Files";
    import TqDisplayFile from "../mediaComponenets/TqDisplayFile";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import {enum_langCodes, enum_lockTypes} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqImgFillBlur from "../basic2/TqImgFillBlur";
    import {FB_QuestBody_Riddle} from "../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "TqMissionsList_row",
        components: {
            TqImgFillBlur,
            TqOnTopContainer,
            TqDisplayFile,
            TqList
        },
        props:{

            p_qb_riddle_c:{
                type: FB_QuestBody_Riddle,
                require: true,
            },
            p_teamStatusMissions_byRiddleId_c:{
                type: Object,
                default() {return {}},
            },
            p_display_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_supportPoints_b:{
                type: Boolean,
                default: false,
            },
            p_windowSizeType_e:{
                type: Number,
                default: enum_screenSizesOptions_n.mobile
            }

        },
        data(){
            return {
                // imports
                ass_strings     : ass_strings,
                ass_img_checked : ass_img_checked,
                ass_img_image   : ass_img_image,
                helper_finishRiddle_fb           : helper_finishRiddle_fb,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
                enum_screenSizesOptions_n       : enum_screenSizesOptions_n,

            }
        },
        methods:{
            m_showFinishIcon_b(qb_riddle_c){

                return helper_finishRiddle_fb(qb_riddle_c, this.p_teamStatusMissions_byRiddleId_c[qb_riddle_c.qbr_riddleId_n])
            },
            m_getWaitingToApprovedImgsNum_fn(qb_riddle_c){

                let riddleId_n = qb_riddle_c.qbr_riddleId_n
                let notApprovedImgs_n = 0

                qb_riddle_c.qbr_locks_ac.forEach((qbr_lock, lockId_n) => {
                    if([enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(qbr_lock.qbrl_type_e)){

                        // check p_teamStatusMissions_byRiddleId_c
                        if(this.p_teamStatusMissions_byRiddleId_c[riddleId_n] == null || this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c == null){return}

                        let rs_unlock_c = this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c[lockId_n]
                        if(rs_unlock_c != null && rs_unlock_c.rsud_lockState_e  === enum_lockState.waitingToApprove){
                            notApprovedImgs_n++
                        }
                    }
                })

                return notApprovedImgs_n
            },
            m_getNotApprovedImgsNum_fn(qb_riddle_c){

                let riddleId_n = qb_riddle_c.qbr_riddleId_n
                let notApprovedImgs_n = 0

                qb_riddle_c.qbr_locks_ac.forEach((qbr_lock, lockId_n) => {
                    if([enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(qbr_lock.qbrl_type_e)){

                        // check p_teamStatusMissions_byRiddleId_c
                        if(this.p_teamStatusMissions_byRiddleId_c[riddleId_n] == null || this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c == null){return}

                        let rs_unlock_c = this.p_teamStatusMissions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c[lockId_n]
                        if(rs_unlock_c != null && rs_unlock_c.rsud_lockState_e  === enum_lockState.notApproved){
                            notApprovedImgs_n++
                        }
                    }
                })

                return notApprovedImgs_n
            },
        }
    }
</script>

<style scoped lang="scss">

    .c_MissionsList{
        text-align: initial;

        .mission{
            cursor: pointer;

            &:hover{
                color: var(--color-gold);
            }
        }
    }

    .noImageLabel{
        height: 60px;
        width: 60px;
        line-height: 60px;
    }


</style>